<div class="blue-bg headerBg">
<div class="max-page-width">

  <nav class="navbar navbar-expand-lg navbar-light  d-flex justify-content-between">

    <div>
     <a class="navbar-brand" href="/">
       <img class="mr-auto logo mt-3" [src]="logo" alt="Agency logo">
     </a>
    </div>

     <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
       <span class="navbar-toggler-icon"><fa-icon [icon]="faBars"></fa-icon></span>
     </button>
     <div class="collapse navbar-collapse justify-content-end" id="navbarText">

       <ul class="navbar-nav">
         <li class="nav-item  header-select d-flex justify-content-end"  *ngIf="isLoggedIn()">
           <div class="notification-header  mr-2">
             <button  disableOptionCentering mat-icon-button class="btn-link" (click)="MyNotifications()"> <mat-icon placement="bottom"  ngbPopover="{{ 'Notifications' | translate }}" triggers="mouseenter:mouseleave" >notifications</mat-icon></button>
           </div>
         </li>

         <li class="nav-item header-select d-flex justify-content-end" >
          <ng-container *ngIf="!paymentFlag" >
            <div class="currency mr-3" >
              <mat-form-field appearance="none">
          <!--       <mat-select [(ngModel)]="selectedCurrency"
                panelClass="header-panel">
                    <mat-option *ngFor="let currency of currencies" [value]="currency">
                      {{currency}}
                    </mat-option>
                  </mat-select> -->
                  <mat-select #CurrencySelect  (selectionChange)="currencyChange(CurrencySelect.value,supportedCurrency)"  [value]="selectedCurrency"
                  disableOptionCentering>
                    <mat-option *ngFor="let currency of supportedCurrency" [value]="currency.currencyID" [selected]="currency.currencyID === selectedCurrency">
                      {{currency.code}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
            <!--  <select [(ngModel)]="selectedCurrency" class="form-control select-control hedder-select turnintodropdown_demo2">
                <option *ngFor="let currency of currencies" [value]="currency"> {{currency}}</option>
              </select>-->


            </div>
          </ng-container>

           <div class="language">
            <mat-form-field appearance="none">
                 <mat-select #langSelect  (selectionChange)="langChange(langSelect.value,supportedLanguages)"  [value]="selectedLanguage"
                 disableOptionCentering>
                   <mat-option *ngFor="let language of supportedLanguages" [value]="language.id" [selected]="language.id === selectedLanguage">
                     {{language.defaultName}}
                   </mat-option>
                 </mat-select>
             </mat-form-field>
             <!-- <select #langSelect (change)="langChange(langSelect.value,supportedLanguages)"  [value]="selectedLanguage" class="form-control  select-control hedder-select turnintodropdown_demo2">
               <option  *ngFor="let language of supportedLanguages" [value]="language.id" [selected]="language.id === selectedLanguage">{{language.defaultName}}</option>
             </select> -->
           </div>

         </li>

         <li class="nav-item header-btn d-flex d-flex justify-content-end">



           <div class="">

           <ng-template
             *ngIf="this.loggedInCustomer != null ;then loggOut; else loggIn">

           </ng-template>

           <ng-template #loggIn>
             <div class="d-flex">
               <a ng-click="body={'background-color':'blue'}" routerLink="/login-page" class="btn btn-loginbtn">{{ 'Login' | translate }}</a>
               <!-- <div class="listyourcars">
                 <button class="btn btn-listyourcars" mat-button>{{ 'ListYourCarsButton' | translate }}</button>
               </div> -->
             </div>
           </ng-template>

           <ng-template #loggOut>

             <div ngbDropdown class="dropdownList">
               <button class="btn user-btn" id="dropdownBasic1" ngbDropdownToggle>
                 <img
               class="rounded-circle user-image mr-2"
               [src]="profilePicUrl"
               />
               <!-- <img class="rounded-circle user-image mr-2" src='assets/img/user-image-default.jpg' /> -->
                 <mat-icon class="fa-s mr-3" *ngIf="evaluationSummary!=null">emoji_events</mat-icon>
                 <span *ngIf="evaluationSummary!=null">{{evaluationSummary.resourceName}} {{evaluationSummary.average}}</span>
               <span *ngIf="evaluationSummary==null">{{loggedInCustomer.firstName}} {{loggedInCustomer.familyName}}</span>
               </button>
               <div class="dropdown-toggle-menu user-menu" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                 <span><button (click)="MyProfile()" mat-menu-item><mat-icon class="user-profile zoom fa-s mr-3">assignment_ind</mat-icon>{{ 'MyProfile' | translate }}</button></span>
                 <hr />
                 <span><button (click)="MyBookings()" mat-menu-item><mat-icon class="user-booking zoom fa-s mr-3">turned_in</mat-icon>{{ 'MyBookings' | translate }}</button></span>
                 <hr />
                 <span><button (click)="MyFavourits()"  mat-menu-item><mat-icon class="user-favorite zoom fa-s mr-3">favorite</mat-icon>{{ 'MyFavourits' | translate }}</button></span>
                 <hr />
                 <span><button class="logout" (click)="logout()"  mat-menu-item><mat-icon class="user-signout zoom fa-s mr-3">settings_power</mat-icon>{{ 'Logout' | translate }}</button></span>
               </div>
             </div>


           </ng-template>



           </div>

         </li>




       </ul>
     </div>
 </nav>


</div>
</div>








  <!-- <nav class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item">
        <img src="https://bulma.io/images/bulma-logo.png">
      </a>
    </div>
  </nav> -->
